import PropTypes from 'prop-types';

/**
 * default colors
 */
export default PropTypes.oneOf([
  'default',
  'primary',
  'secondary',
  'info',
  'success',
  'warning',
  'danger',
  'transparent',
]);
